<template>
    <div id="main-treeview" 
        class="treeview"
    >
        <!-- 依照 item-key 來決定要靠 items 中哪一項 property 來控制 tree 的開關-->
        <v-treeview 
            v-model="tree" 
            :open="opened_layers" 
            :items="items" 
            :item-key="(['atlas', 'forecast_observation', 'monitor', 'geomap'].includes(current_tab)) ? 'id' : 'name'" 
            open-on-click
        >
            <template #prepend="{ item }">
                <v-icon v-if="item.node && item.layer1 && item.icon" 
                    color="white"
                >
                    {{ item.icon }}
                </v-icon>
                <v-checkbox 
                    v-if="in_special_list(item.id) && !item.node"
                    class="checkbox-position"
                    :class="{
                        'radio_style': item.type === 'optional_radio'
                    }"
                    :disabled="tree_view_disabled" 
                    v-model="selectors[item.id].checked" 
                    @change="control_special_func(item)"
                />
                <v-checkbox
                    v-else-if="item.type == 'optional_radio' && !item.node"
                    class="checkbox-position radio_style"
                    :disabled="tree_view_disabled" 
                    v-model="selectors[item.id].checked" 
                    @change="check_optional_radio(item)"
                />
                <v-checkbox
                    v-else-if="item.type == 'cross_type_single_radio' && !item.node"
                    class="checkbox-position radio_style"
                    :disabled="tree_view_disabled" 
                    v-model="selectors[item.id].checked" 
                    @change="check_all_single_radio(item)"
                />
                <v-checkbox 
                    v-else-if="item.type == 'checkbox' && !item.node"
                    class="checkbox-position"
                    :disabled="tree_view_disabled" 
                    v-model="selectors[item.id].checked" 
                    @change="check_other_radio(selectors[item.id].checked, item)"
                />
                <v-checkbox 
                    v-else-if="item.type == 'check_all' && enable_all_select_in_treeview_children_radios"
                    class="checkbox-position"
                    v-model="selectors[item.id].checked" 
                    @change="change_all_checkbox_status(selectors[item.id].checked, item)"
                />
                <v-checkbox v-else-if="item.type == 'slider'" 
                    class="checkbox-position"
                    :class="{
                        radio_style: item.sliders_checkbox_style === 'radio'
                    }"
                    v-model="selectors[item.id].checked" 
                    @change="control_slide_check_selector(item)"
                />
            </template>
            <template #append="{ item }">
                <template v-if="item.node && item.radio_name">
                    <div v-if="selected_product_count_record[item.radio_name.replace('root', '')] > 0" 
                        class="selected-product-count"
                    >
                        <div class="selected-product-count__text">
                            {{ selected_product_count_record[item.radio_name.replace('root', '')] }}
                        </div>
                    </div>
                </template>
                <div v-if="item.information && item.information.length > 0">
                    <InformationTooltip
                        :information="item.information"
                    />
                </div>
            </template>
            <template #label="{ item }">
                <a v-if="item.type == 'link'"
                    :href="item.href"
                    target="_blank"
                >{{ item.name }}</a>
                <template v-else>
                    {{ item.name }}
                </template>
                <template v-if="link_icon_list.includes(item.id)">
                    <v-icon>mdi-launch</v-icon>
                </template>
                <template v-if="enable_custom_label">
                    <slot name="content" 
                        :item="item"
                    />
                </template>
                <template v-if="item.type == 'slider'">
                    <MenuSlider v-if="item.sliders"
                        class="slider__wrapper" 
                        :ref="item.id"
                        :item="item"
                        :tick_id="selectors[item.id].tick"
                        :slider_ticks_mapping="slider_ticks_mapping"
                        @change-slider-tick="control_slide_check_selector"
                    />
                </template>
            </template>
        </v-treeview>
    </div>
</template>

<script>
/* 
    這個元件的資料傳遞，似乎目前都是剛好被 call by reference 改動的，
    需要重新修改成用 props emit 的邏輯去做 selector 的連動工作
*/
    import { mapState } from 'vuex'

    export default {
        name: 'TreeView',

        components: {
            InformationTooltip: () => import('@/components/notification/information_tooltip.vue'),
            MenuSlider: () => import('@/components/tool/menu_slider.vue')
        },

        props: {
            name: {
                type: String,
                default () {
                    return 'others'
                }
            },            

            init_items: {
                type: Array,
                default () {
                    return [{'a': 1}]
                }
            },

            slider_ticks_mapping: {
                type: Object,
                default () {
                    return {}
                }
            },

            checked_selectors: {
                type: Object,
                default () {
                    return {}
                }
            },

            init_opened_layers: {
                type: Array,
                default () {
                    return [{'b': 2}]
                }
            },

            opened_with_btn: {
                type: Boolean,
                default () {
                    return false
                }
            },

            // functions
            check_function: {
                type: Function,
                default () {
                    return () => {}
                }
            },

            enable_all_select_in_treeview_children_radios: {
                type: Boolean,
                default () {
                    return false
                }
            },

            special_list: {
                type: Array,
                default () {
                    return []
                }
            },

            selected_product_count_callback: {
                type: Function,
                default () {
                    return (accum) => accum
                }
            },

            // for timechoose.vue
            enable_custom_label: {
                type: Boolean,
                default () {
                    return false
                }
            },

            current_tab: {
                type: String,
                default () {
                    return ''
                }
            }
        },
        
        data() {
            return {
                tree: [],
                items: [],
                selectors: {},
                opened_layers: [],
                btn_obj: {0: true},
                click_node_count: 0,
                tree_view_disabled: false,
                event_not_added: true,
                link_icon_list: ['atlas_24'],

                open_layer_language_tag: this.language
            }
        },

        computed: {
            ...mapState([
                'language'
            ]),
            
            selected_product_count_record() {
                return Object.values(this.selectors).reduce(this.selected_product_count_callback(), {})
            }
        },

        watch: {
            checked_selectors: {
                handler() {
                    this.selectors = this.checked_selectors;

                    setTimeout(() => {
                        this.event_not_added && this.add_event();
                    }, 0)
                },
                deep: true,
                immediate: true,
            },

            init_items: {
                handler() {
                    this.items = this.init_items;

                    if (this.open_layer_language_tag !== this.language) {
                        this.opened_layers = this.init_opened_layers;
                        this.open_layer_language_tag = this.language
                    }
                },
                deep: true,
                immediate: true
            },

            selected_product_count_record: {
                deep: true,
                immediate: true,
                handler() {
                    // 需要等待 vuetify treeview 本身 dom 切換完成
                    setTimeout(() => {
                        const has_selected_product_doms  = document.querySelectorAll('.selected-product-count__root')
                        has_selected_product_doms.forEach((dom) => {
                            dom.classList.remove('selected-product-count__root')
                        })

                        const count_doms = document.querySelectorAll('.selected-product-count');
                        [...count_doms].map(dom => dom.parentNode.parentNode)
                            .forEach(parent_dom => {        
                                parent_dom.classList.add('selected-product-count__root');
                            })
                    }, 0)
                }
            }
        },

        methods: {
            in_special_list(id) {
                return this.special_list.includes(id)
            },

            control_special_func({ index, radio_name, name, id }) {
                this.$emit('control_special_list', index, radio_name, name, id)
            },

            check_optional_radio({ index, radio_name, name, data_group, data_tag }) {
                Object.values(this.selectors).forEach(selector => {
                    if (selector.data_group === data_group && selector.data_tag !== data_tag) {
                        this.$set(selector, 'checked', false)
                    }
                })
                this.check_function(index, radio_name, name);
            },

            check_all_single_radio({ id: checked_id }) {
                Object.values(this.selectors).forEach(selector => {
                    if (selector.id !== checked_id) {
                        this.$set(selector, 'checked', false)
                    } else {
                        setTimeout(() => this.$set(selector, 'checked', true), 0)
                    }
                })

                this.check_function(checked_id);
            },

            check_other_radio(checked, check_params) {
                this.check_function(check_params);

                const id_belongs = check_params.id.split('_')[1]
                const check_all_selectors = Object.values(this.selectors).find((selector) => {
                    return selector.id === `id_${id_belongs}_check_all`
                })
                if (check_all_selectors) {
                    if (check_all_selectors.checked) {
                        if (!checked) this.$set(check_all_selectors, 'checked', false);
                    } else {
                        const same_belongs_selectors = Object.values(this.selectors).filter((selector) => {
                            return selector.id !== `id_${id_belongs}_check_all` && selector.id_belongs === `id_${id_belongs}`
                        })
                        const checked_array = same_belongs_selectors.filter(selectors => selectors.checked);
                        const is_check_all = checked_array.length === same_belongs_selectors.length;
                        check_all_selectors.checked = is_check_all
                    }
                }
            },

            change_all_checkbox_status(checked, { id_group }) {
                Object.values(this.selectors).forEach((selector) => {
                    if(selector.id_belongs === id_group) {
                        this.$set(selector, 'checked', checked);
                    }
                })
            },

            close_all_trees() {
                this.opened_layers = [];
            },        

            add_event() {
                const tree_node = document.querySelectorAll(`#${this.name} .v-treeview > .v-treeview-node`);
                if (typeof tree_node != 'undefined' && tree_node != null) {
                    this.event_not_added = false;
                    //tree_node是NodeList
                    [...tree_node].map( node => {
                        node.addEventListener('click', this._click_text_event); 
                    })
                }
            },

            _click_text_event(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                
                if (e.target.classList.contains('v-treeview-node__label')) {
                    const ripple = e.target.parentNode.querySelector('.v-input--selection-controls__ripple')
                    ripple && ripple.click();
                }
            },

            control_slide_check_selector(item, tick_selected){
                const { id } = item
                if (tick_selected) {
                    this.selectors[id].tick = tick_selected
                }

                const is_check = this.selectors[id].checked
                if (is_check) {
                    this.check_optional_radio(item)
                    const selected_slide = this.$refs[id].selected_slide
                    const product_id = selected_slide.id
                    this.selectors[product_id].checked = true
                } else {
                    const slider_ids = this.$refs[id].sliders.map(({ id }) => id)
                    slider_ids.forEach(id => {
                        this.selectors[id].checked = false
                    })
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .treeview {
        touch-action: pan-x pan-y;
    }

    .menu-icon {
        width: 24px;
        height: 24px;
    }

    .selected-product-count {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        background-color: rgba(255, 255, 255, .4);
        border-radius: 2px;

        &__text {
            font-size: 16px;
            font-family: NotoSansCJKtc, sans-serif;
            color: #fff;
        }
    }
</style>

<style scoped>
    .treeview >>> .v-treeview-node__root {
        min-height: 40px;
        border-top: 1px solid#e8ecf7;
        background-image: linear-gradient(to right, #334162 0%, #34525f 100%);
        color: #fff;
    }

    .treeview >>> .v-treeview-node--leaf {
        margin-left: .375rem;
        padding: .375rem 0 .375rem .375rem;
        touch-action: pan-x pan-y;
    }

    /* leaf checkbox 對齊 父node */
    .treeview >>> .v-treeview-node--leaf > .v-treeview-node__root {
        padding-left: 26px;
        touch-action: pan-x pan-y;
    }

    .treeview >>> .v-treeview-node__children {
        position: relative;
        touch-action: pan-x pan-y;
    }

    .treeview >>> .v-treeview-node__children::before {
        content: '';
        position: absolute;
        display: inline-block;
        margin-left: 12px;
        width: 1px;
        height: 100%;
        background: var(--base-gray-darken);
        z-index: 1;
    }

    /* 子 node 不需要最上層的效果 */
    .treeview >>> .v-treeview-node__children .v-treeview-node__root {
        border-top: 0;
        background: var(--base-gray);
    }

    /* 子 node 對齊 父node  */
    .treeview >>> .v-treeview-node__children > :not(.v-treeview-node--leaf) {
        margin-left: 39px;
    }

    .treeview >>> .v-treeview-node__children .v-treeview-node__label {
        margin-top: 4px;
        white-space: normal;
    }

    .treeview >>> .v-input--selection-controls.v-input {
        margin-top: 0;
    }

    .treeview >>> .v-treeview-node__content {
        align-items: flex-start;
    }

    .treeview >>> .v-messages {
        min-height: initial;
    }

    .treeview >>> .mdi-menu-down::before {
        width: 34px;
        height: 34px;
    }

    .treeview >>> .v-icon, .treeview >>> a {
        color: #fff;
    }

    .treeview >>> .selected-product-count__root {
        z-index: 1;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .24);
        background-image: linear-gradient(72deg, #304476 18%, #319da9 85%);
    }

    .treeview >>> .v-treeview-node__content > .mdi::before {
        margin: 0 .2em;
    }

    /* 把 checkbox 轉成 radio 樣式  */
    .radio_style >>> .mdi-checkbox-blank-outline::before {
        /* F43D 中間沒東西 */
        content: '\F43D';
    }

    .radio_style >>> .mdi-checkbox-marked::before {
        /* F43E 中間有東西 */
        content: '\F43E';
    }
</style>